<template>
  <div class="flex flex-col" style='box-sizing:border-box'>
    <div id='topoftext' class="w-full grow flex flex-row justify-center">
      <pbc-button @click='onSave' class="py-2 px-2 flex-none pbc-primary-color" :disabled='validationErrorImage' >
        <post class="mx-2"/>
        <span class="mr-2">Continue</span>
      </pbc-button>

    </div>

    <div class="overflow-y-auto">
      <img id='memeimage' ref='image' v-if='image !== ""' :src='api.makeImageUrlEditor(image)'
           class="object-contain"
           />
      <p v-if='validationErrorImage' class="text-red-500 text-xs italic">Upload an image.</p>
      <image-uploader :game-id='parentId'
                      @select='onSelectImage'
                      :single-upload='true'
                      :already-uploaded='[]' 
                      class="h-48 mb-4"
                      />

    </div>

    <div class="w-full grow flex flex-row justify-center">
      <pbc-button @click='onSave' class="px-2 py-2 flex-none pbc-primary-color" :disabled='validationErrorImage' >
        <post class="mx-2"/>
        <span class="mr-2">Continue</span>
      </pbc-button>
    </div>

    <auth-dialog v-if='promptUserLogin'
                 @close='onCloseAuthDialog'
                 @guest='onGuest'
                  :login-state='loginState'/>

  </div>

</template>
<script>
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import AuthDialog from '@ui/organisms/AuthDialog.vue';
import Post from '@icons/Post.vue';
export default {
  inject: ['api'],
  props: {
    parentId: {
      type: String,
      required: true
    },
    opId: {
      type: String,
      required: true
    },
  },
  mounted() {
    console.log('fokken params', this.$route.params);
    if (this.$route.params.autoPost) {
      this.image = this.$route.params.image;
      this.title = this.$route.params.title;
      this.onSave();
    }

    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editImagePostOpen'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editImagePostClose'
    });
  },
  data() {
    return {
      image: '',
      validationErrorImage: true,
      promptUserLogin: false,
      loginState: {}
    }
  },
  components:{
    Post,
    AuthDialog,
    ImageUploader
  },
  methods:{
    onSelectImage({id}) {
      this.image = id;
      this.validate();

      document.querySelector('#after-upload').scrollIntoView({
        behavior: 'smooth'
      });
    },
    onEditImmediately() {
      console.log('go there');
      this.$router.replace({
        name:'start',
        params:{
          parentId:this.parentId,
          type:'post',
          __autoRemixImage: this.image,
          __autoRemixTitle: ''
        }
      });
    },
    onSave(skipLoggedInCheck = false) {

      this.onEditImmediately();
      return;

      if (!this.validate()) {
        return;
      }
      this.validationErrorImage = false;

      if (!skipLoggedInCheck) {
        this.$ana.track({
          eventCategory:'engagement',
          eventAction:'attemptPost',
          extra:{type:'image'}
        });
      }

      if (!skipLoggedInCheck && !this.$store.state.loggedIn) {

        this.promptUserLogin = true;

        this.loginState = {
          redirect: 'image',
          parentId: this.parentId,
          opId: this.opId,
          title: this.title,
          image: this.image
        }
        return;
      }

      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'madePost',
        extra:{type:'image'}
      });
      this.$gtag.event('conversion', {'send_to': 'AW-801440214/QHGnCL_UzskBENaDlP4C'});

      console.log('sigh');
      this.$emit("save", {
        parentId: this.parentId,
        opId: this.opId,
        title: this.title,
        image: this.image
      });

      this.promptUserLogin = false;

    },
    onGuest() {
      console.log('will guest');
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'continueAnonymous',
        extra:{type:'image'}
      });

      this.promptUserLogin = false;
      this.onSave(true);
    },
    onCloseAuthDialog() {
      this.promptUserLogin = false;
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'closeAuth',
        extra:{type:'image'}
      });

      //this.onSave();
    },
    validate() {
      if (!this.image || this.image === '') {
        this.validationErrorImage = true;
        return false;
      }
      this.validationErrorImage = false;
      return true;
    },

  },
  computed:{
    titleInputClasses() {
      const classes = ["pbc-standard-input", "text-xl", "my-1", "grow"];
      if (this.validationErrorImage) {
        classes.push("border-red-500 border border-2");
      }
      return classes;
    }

  }
}
</script>
